import React, { useContext, useEffect, useState } from "react";
import successIcon from "../../images/successGreenIcon.png";
import errorIcon from "../../images/errorRedIcon.png";
import LoadingIcon from "../../images/Loading_icon.gif";
import { ListDetailsContext } from "../../contexts/ListDetailsContext";
import { UrlContext } from "../../contexts/UrlContext";

export default function ExHourlyRate({
  hourlyRate,
  expert_id,
  hourlyRateCurrency,
}) {
  const [value, setValue] = useState("");
  const [returnSuccess, setReturnSuccess] = useState(false);
  const [returnError, setReturnError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [hourlyCurrency, setHourlyCurrency] = useState("");
  const { tableData, setTableData, fieldsLoading } =
    useContext(ListDetailsContext);
  const { API_URL } = useContext(UrlContext);
  useEffect(() => {
    if (hourlyRate === "None" || hourlyRate === null) return;
    setValue(hourlyRate);
    setHourlyCurrency(hourlyRateCurrency);
  }, [hourlyRate, hourlyRateCurrency]);

  const changeHourlyRate = (newValue) => {
    setReturnError(false);
    setLoading(true);
    const url = `${API_URL}change-hourly-rate`;
    const data = {
      expert_id,
      hourlyRate: newValue,
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.status === "success") {
          setReturnSuccess(true);
          setTimeout(() => {
            setReturnSuccess(false);
          }, 1500);
          setTableData(
            tableData.map((item) => {
              if (item.expert.ID === expert_id) {
                item.expert.hourly_rate = newValue;
              }
              return item;
            })
          );
        } else {
          setReturnError(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        setReturnError(true);
        console.log(err);
      });
  };

  const changeHourlyCurrency = (newValue) => {
    setReturnError(false);
    setLoading(true);
    const url = `${API_URL}update-expert-hourly-currency/` + expert_id;
    const data = {
      hourly_currency: newValue,
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.status === "success") {
          setReturnSuccess(true);
          setTimeout(() => {
            setReturnSuccess(false);
          }, 1500);
          setTableData(
            tableData.map((item) => {
              if (item.expert.ID === expert_id) {
                item.expert.hourly_rate_currency = newValue;
              }
              return item;
            })
          );
        } else {
          setReturnError(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        setReturnError(true);
        console.log(err);
      });
  };

  return (
    <>
      {!fieldsLoading ? (
        <>
          <select
            className="prj-summ-currency-daily"
            value={hourlyRateCurrency}
            style={{ marginLeft: "5px" }}
            onChange={(e) => {
              setHourlyCurrency(e.target.value);
              changeHourlyCurrency(e.target.value);
            }}
          >
            <option value="">---</option>
            <option value="EUR">EUR</option>
            <option value="USD">USD</option>
            <option value="GBP">GBP</option>
            <option value="CHF">CHF</option>
            <option value="AUD">AUD</option>
            <option value="AED">AED</option>
            <option value="INR">INR</option>
          </select>
          <input
            placeholder="Hourly rate"
            value={value}
            style={{ width: "60%" }}
            onChange={(e) => setValue(e.target.value)}
            onBlur={(e) => changeHourlyRate(e.target.value)}
          />
        </>
      ) : (
        <img
          className="return-msg-icon"
          style={{ top: "6px", right: "0" }}
          src={LoadingIcon}
          alt="loading"
          title="Loading..."
        />
      )}
      {loading && (
        <img
          className="return-msg-icon"
          style={{ top: "6px", right: "0" }}
          src={LoadingIcon}
          alt="loading"
          title="Loading..."
        />
      )}
      {returnSuccess && (
        <img
          className="return-msg-icon"
          style={{ top: "6px", right: "0" }}
          src={successIcon}
          alt="success"
          title="Success"
        />
      )}
      {returnError && (
        <img
          className="return-msg-icon"
          style={{ top: "6px", right: "0" }}
          src={errorIcon}
          alt="error"
          title="Error! Please reload"
        />
      )}
    </>
  );
}
